import {
  ArrowDownOutlined,
  FullscreenOutlined,
  LeftOutlined,
  RedoOutlined,
  RightOutlined,
  CheckOutlined,
} from '@ant-design/icons';
import { Modal, Dropdown, Menu, message } from 'antd';
import React, { useState } from 'react';
import { styled } from 'troyfe';
import { imgUrlHandle, fileDownLoad } from '@/utils';
import ZipDownload from '@/helper/zipDownload';


const Block = styled.div`
  background: rgba(0, 2, 6, 0.5);
  position: relative;

  .prev,
  .next {
    &:hover {
      background: rgba(0, 0, 0, 0.5);
    }

    width: 40px;
    height: 70px;
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    z-index: 1000;
    cursor: pointer;
    font-size: 16px;
    top: 40%;
    color: #fff;
    text-align: center;
    line-height: 70px;
  }

  .prev {
    left: 0px;
  }

  .next {
    right: 0px;
  }

  .img {
    height: 600px;
    width: 45vw;
    overflow: hidden;
    margin: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .tool {
    display: flex;
    position: absolute;
    top: 15px;
    right: 20px;
    cursor: pointer;
    z-index: 1000;

    li {
      &:hover {
        background: rgba(0, 0, 0, 0.7);
      }

      margin-right: 10px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.3);
      color: #fff;
      text-align: center;
      line-height: 40px;
      font-size: 25px;
    }
  }

  .jmh_box_bottom {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    margin: auto;
    overflow-x: scroll;
    background: rgba(0, 2, 6, 0.2);

    li {
      margin: 5px;
      position: relative;

      .download {
        position: absolute;
        right: 3px;
        top: 3px;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: #fff;
        cursor: pointer;
        text-align: center;
        line-height: 15px;
        z-index: 1;
      }

      img {
        width: 160px;
        height: 90px;
      }
    }
  }
`;
const index = (props) => {
  const {
    imgIsVisible,
    // list = [
    //   {
    //     url:
    //       'https://wx1.sinaimg.cn/orj360/005Ep76ngy1gs57v28qwyj32c02c0h3a.jpg'
    //   },
    //   {
    //     url:
    //       'https://wx1.sinaimg.cn/orj360/005Ep76ngy1gruw1r8dlrj32bx2bxtxy.jpg'
    //   },
    //   {
    //     url:
    //       'https://wx1.sinaimg.cn/orj360/005Ep76ngy1gq5kp18i9jj32c03404qw.jpg'
    //   },
    //   {
    //     url:
    //       'https://wx1.sinaimg.cn/orj360/005Ep76ngy1gs57v28qwyj32c02c0h3a.jpg'
    //   },
    //   {
    //     url:
    //       'https://wx1.sinaimg.cn/orj360/005Ep76ngy1gruw1r8dlrj32bx2bxtxy.jpg'
    //   },
    //   {
    //     url:
    //       'https://wx1.sinaimg.cn/orj360/005Ep76ngy1gq5kp18i9jj32c03404qw.jpg'
    //   },
    //   {
    //     url:
    //       'https://wx1.sinaimg.cn/orj360/005Ep76ngy1gs57v28qwyj32c02c0h3a.jpg'
    //   },
    //   {
    //     url:
    //       'https://wx1.sinaimg.cn/orj360/005Ep76ngy1gruw1r8dlrj32bx2bxtxy.jpg'
    //   },
    //   {
    //     url:
    //       'https://wx1.sinaimg.cn/orj360/005Ep76ngy1gq5kp18i9jj32c03404qw.jpg'
    //   }
    // ],
    setImgIsVisible,
    tableObj,
    queryPageListObj,
    // list
  } = props;
  const http = sessionStorage.getItem('httpUrl');
  const list = tableObj.fileList || [];
  const [select, setSelect] = useState([]);
  const [rotate, setRotate] = useState(0);
  const [downloadType, setDownloadType] = useState(false);
  // const list = queryPageListObj.imageUrl || []
  const [current, setCurrent] = useState(0);
  const next = () => {
    if (current <= list.length - 2) {
      setCurrent(current + 1);
    }
  };

  const prev = () => {
    if (current !== 0) {
      setCurrent(current - 1);
    }
  };
  const menu = (
    <Menu>
      <Menu.Item
        key={0}
        onClick={() => {
          console.log(select, 'select');
          if (select.length === 1) {
            fileDownLoad(imgUrlHandle(`${http}/${list[current]}`), 'img');
          } else {
            const filesData = [];
            select.map((it, i) => {
              filesData.push({
                name: `文件${i + 1}`,
                url: list[it],
              });
            });
            if (filesData.length) {
              ZipDownload(filesData, 'auto', 'auto');
            } else {
              message.warning('似乎什么也没有呢~');
            }
          }
        }}
      >
        下载选中
      </Menu.Item>
      <Menu.Item
        key={1}
        onClick={() => {
          const filesData = list.map((it, i) => {
            return {
              name: `文件${i + 1}`,
              url: imgUrlHandle(it),
            };
          });
          if (filesData.length) {
            ZipDownload(filesData, 'auto', 'auto');
          } else {
            message.warning('似乎什么也没有呢~');
          }
        }}
      >
        下载所有
      </Menu.Item>
    </Menu>
  );
  return (
    <Modal
      title={`图片(${list.length})`}
      visible={imgIsVisible}
      getContainer={false}
      width="60%"
      footer={null}
      onCancel={() => {
        setImgIsVisible(false);
      }}
    >
      <Block>
        <ul className="tool">
          <li
            onClick={() => {
              window.open(imgUrlHandle(`${http}/${list[current]}`));
            }}
          >
            <FullscreenOutlined />
          </li>
          <li
            onClick={() => {
              setRotate(rotate + 90);
            }}
          >
            <RedoOutlined />
          </li>
          <li
            onClick={() => {
              setDownloadType(true);
            }}
          >
            <Dropdown overlay={menu} placement="bottomLeft">
              <ArrowDownOutlined />
            </Dropdown>
          </li>
        </ul>
        <div onClick={() => prev()} className="prev">
          <LeftOutlined />
        </div>
        <div className="img">
          <img
            style={{
              transform: `translateX(0) translateY(0) rotate(${rotate}deg)`,
            }}
            src={list.length > 0 && imgUrlHandle(`${http}/${list[current]}`)}
            alt="图片"
          />
        </div>
        <div className="next" onClick={() => next()}>
          <RightOutlined />
        </div>
        <ul className="jmh_box_bottom">
          {list.map((item, index) => {
            return (
              <li key={index} onClick={() => setCurrent(index)}>
                {downloadType && (
                  <div
                    className="download"
                    style={{
                      color: select.includes(index) ? '#44BB55' : '#fff',
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      const key = select.indexOf(index);
                      if (key > -1) {
                        const newData = select;
                        newData.splice(key, 1);
                        setSelect([...newData]);
                      } else {
                        setSelect([...select, index]);
                      }
                    }}
                  >
                    <CheckOutlined />
                  </div>
                )}
                <img
                  src={imgUrlHandle(`${http}/${item}`)}
                  alt="图片"
                  style={{
                    border: index === current ? '2px solid #44BB55' : 'none',
                    filter: index !== current ? 'brightness(0.5)' : 'none',
                  }}
                />
              </li>
            );
          })}
        </ul>
      </Block>
    </Modal>
  );
};

export default index;
